import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import "./userProfile.scss";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import SlideInModal from "../../components/slideInModal/SlideInModal";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/dateFormat";
import Loading from "../../components/loading/Loading";

const Orders = () => {
  const navigate = useNavigate();
  const { buyer, dispatch } = useContext(AuthContext);
  const [orders, setOrders] = useState([]);
  const [selectedOderId, setSelectedOderId] = useState("");
  const [isModalOpen, setIsModalOpen] = useState("");
  const [orderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(false);

  const buyerId = buyer._id;

  const columns = [
    { field: "date", headerName: "Date", width: 150 },
    { field: "orderId", headerName: "Order ID.", width: 200 },
    { field: "orderStatus", headerName: "Order Status", width: 150 },
    { field: "paymentMethod", headerName: "Payment Method", width: 150 },
    { field: "paymentStatus", headerName: "Payment Status", width: 150 },
    { field: "deliveryCost", headerName: "Delivery Cost", width: 120 },
    { field: "totalAmount", headerName: "Total Amount", width: 120 },
  ];

  useEffect(() => {
    const getAllOrders = async () => {
      try {
        const response = await axios.get(`/get-buyer-orders/${buyerId}`);

        const mappedOrders = response.data.map((order) => ({
          id: order._id, // for DataGrid's internal use
          orderId: order.orderId || "",
          customer: order.fullName || "",
          brand: order.brand || "",
          city: order.city || "",
          address: order.address || "",
          homeName: order.homeName || "",
          landmark: order.landmark || "",
          orderStatus: order.orderStatus || "",
          paymentMethod: order.paymentMethod || "",
          paymentStatus: order.paymentStatus || "",
          totalAmount: order.totalAmount || 0,
          deliveryCost: order.deliveryCost || 0,
          productsList: order.products || [],
          date: formatDate(order.createdAt || []),
        }));

        setOrders(mappedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    getAllOrders();
  }, []);

  useEffect(() => {
    if (!selectedOderId) {
      return;
    }
    const getOderDetails = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-order-data/${selectedOderId}`);
        setOrderData(response.data);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };
    getOderDetails();
  }, [selectedOderId]);

  return (
    <>
      <SlideInModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <div className="oder_details">
            <div className="p_sec">
              <div className="p_in">
                <div>
                  <span>Order ID :</span>{" "}
                  <span style={{ color: "orange" }}>{orderData.orderId}</span>
                </div>
                <h5 style={{ fontWeight: "600" }}>{orderData?.fullName}</h5>

                <div className="ad_wrp">
                  <span>Address</span>
                  <p>
                    {orderData.address}, {orderData.homeName},{" "}
                    {orderData.landmark}, {orderData.city}
                  </p>
                </div>
              </div>
              <div className="p_in">
                <div className="p_data">
                  <p>Payment Status :</p>
                  <p>
                    <em>{orderData.paymentStatus}</em>
                  </p>
                </div>
                <div className="p_data">
                  <p>Payment Method :</p>
                  <p>
                    <em>{orderData.paymentMethod}</em>
                  </p>
                </div>
                <div className="p_data">
                  <p>Order Status :</p>
                  <p>
                    <em>{orderData.orderStatus}</em>
                  </p>
                </div>
                <div className="p_data">
                  <p>Order Date :</p>
                  <p>
                    <em>{formatDate(orderData.createdAt)}</em>
                  </p>
                </div>
              </div>
            </div>
            <div className="products-list">
              {Array.isArray(orderData.products) &&
              orderData.products.length > 0 ? (
                <>
                  <ul>
                    {orderData.products.map((item, i) => (
                      <li key={i} className="product-item">
                        <span className="num">{i + 1}</span>
                        <span className="p-name">{item.title}</span>
                        <div className="od_data">
                          <span className="p-qty">{item.quantity}kg</span>
                          <span className="p-price">{item.price} AED</span>
                          <span className="p-weight">
                            {item.price * item.quantity} AED
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <br />
                  <div className="order-total">
                    <strong>Total Amount:</strong>{" "}
                    <strong>{orderData.totalAmount} AED</strong>
                  </div>
                </>
              ) : (
                <p>No Products Found</p>
              )}
            </div>
          </div>
        )}
      </SlideInModal>

      <div className="main_wrp">
        <div className="main_page_wrp">
          <div className="head_wrp">
            <h5>
              My <em>Orders</em>
            </h5>
          </div>
          <div className="main_body_wrp">
            <DataGrid
            style={{cursor:"pointer"}}
              rows={orders}
              columns={columns}
              pageSize={5}
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              slots={{ toolbar: GridToolbar }}
              onCellClick={(params) => {
                setSelectedOderId(params.row.id);
                setIsModalOpen(true);
              }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
